export const isTileVerticallyVisible = (container: HTMLElement, tileElement: HTMLElement) => {
    const containerBottom = container.getBoundingClientRect().bottom;
    const tileTop = tileElement.getBoundingClientRect().top;
    return tileTop < containerBottom;
};
